import qs from 'qs'
export default class serve {
    static fetchPost(url, param) {
        return new Promise((resolve, reject) => {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': window.token_type + ' ' + window.token
                }
            };
            axios.post(url, param, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static fetchPut(url, param) {
        return new Promise((resolve, reject) => {
            let config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': window.token_type + ' ' + window.token
                }
            };
            let readyData = qs.stringify(param);
            axios.put(url, readyData, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static fetchPatch(url, param) {
        return new Promise((resolve, reject) => {
            let config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': window.token_type + ' ' + window.token
                }
            };
            let readyData = qs.stringify(param);
            axios.patch(url, readyData, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static fetchUpload(url, param) {
        return new Promise((resolve, reject) => {
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': window.token_type + ' ' + window.token
                }
            };
            axios.post(url, param, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static fetchGet(url, param) {
        return new Promise((resolve, reject) => {
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': window.token_type + ' ' + window.token
            }
            axios.get(url, {
                headers: headers,
                params: param,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'brackets' })
                }
            }) .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error.response)
                    reject(error);
                });
        });
    }

    static fetchDownload(url, param) {
        return new Promise((resolve, reject) => {
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': window.token_type + ' ' + window.token
            }
            axios.get(url, {
                headers: headers,
                params: param,
                responseType: 'blob',
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'brackets' })
                }
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error.response)
                    reject(error);
                });
        });
    }

    static fetchDelete(url, param) {
        return new Promise((resolve, reject) => {
            let headers = {
                'Content-Type': 'application/json',
                'Authorization': window.token_type + ' ' + window.token
            }
            axios.delete(url, {
                headers: headers,
                params: {}
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/serve/serve.js